import { Controller } from "@hotwired/stimulus";
import {
  computePosition,
  flip,
  shift,
  offset,
  autoUpdate,
} from "@floating-ui/dom";

// Connects to data-controller="field-picker"
// A small floating popover (Floating UI) anchored to the trigger that opened
// it, holding a choices.js select. Several triggers (e.g. the per-ticket
// currency symbols) can share one menu — it re-anchors to whichever is clicked.
// Floating, so the choices dropdown isn't clipped the way it is inside a
// native popover.
export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.onOutside = this.onOutside.bind(this);
    this.onKey = this.onKey.bind(this);
  }

  disconnect() {
    this.stop();
  }

  toggle(event) {
    if (this.menuTarget.hidden) {
      this.open(event.currentTarget);
    } else {
      this.close();
    }
  }

  open(anchor) {
    this.anchor = anchor;
    this.menuTarget.hidden = false;
    this.cleanup = autoUpdate(anchor, this.menuTarget, () => this.position());
    document.addEventListener("pointerdown", this.onOutside, true);
    document.addEventListener("keydown", this.onKey);
  }

  close() {
    this.menuTarget.hidden = true;
    this.stop();
  }

  stop() {
    if (this.cleanup) {
      this.cleanup();
      this.cleanup = null;
    }
    document.removeEventListener("pointerdown", this.onOutside, true);
    document.removeEventListener("keydown", this.onKey);
  }

  async position() {
    const { x, y } = await computePosition(this.anchor, this.menuTarget, {
      placement: "bottom-start",
      strategy: "fixed",
      middleware: [offset(6), flip(), shift({ padding: 8 })],
    });
    Object.assign(this.menuTarget.style, {
      position: "fixed",
      left: `${x}px`,
      top: `${y}px`,
    });
  }

  onOutside(event) {
    if (
      this.menuTarget.contains(event.target) ||
      this.anchor?.contains(event.target)
    ) {
      return;
    }
    this.close();
  }

  onKey(event) {
    if (event.key === "Escape") this.close();
  }
}
